<template>
    <div class="navbar w3-bar w3-black">
        <router-link id="signature" class="navitem w3-bar-item w3-button w3-large w3-mobile" to="/">Sam Depretis</router-link>
        <a href="https://www.linkedin.com/in/sam-depretis-1a4474b1">
            <div class="navitem w3-bar-item w3-button w3-large w3-right w3-mobile">
                <img class="linkedin" src="../assets/linkedin.png">
            </div>
        </a>
        <router-link class="navitem w3-bar-item w3-button w3-large w3-right w3-mobile" to="/3dModels">3d Models</router-link>
        <router-link class="navitem w3-bar-item w3-button w3-large w3-right w3-mobile" to="/technologies">Technologies I use</router-link>
        <router-link class="navitem w3-bar-item w3-button w3-large w3-right w3-mobile" to="/work">Work History</router-link>
    </div>
</template>

<script>
export default {

}
</script>

<style>

.navitem {
    color: #FBF0E5;
    padding-left: 3em;
    padding-right: 3em;
    font-family: 'Pangolin', cursive;
}

.linkedin {
    max-height: 1.8em;
    max-width: 1.8em;
}

#signature {
    font-family: 'Pacifico', cursive;
    font-size: 20em;
    min-width: 5em;
    color: #FBF0E5;
    float: left;
}

</style>